<template>
    <div :is="$route.params.layout === 'mng' ? 'el-card' : 'slot'">
    
        <el-form @submit.native.prevent="submitForm('ruleForm')" :model="article" :rules="rules" ref="ruleForm" label-width="120px" class="mr-5">
            <!-- <p class="text-center mb-4 fs15 text-primary2">소속된 업체의 담당자만 가입이 가능합니다. 가입을 위해 소속업체를 선택하세요</p> -->

            <!-- <hr class=""/> -->

            <el-row v-if="boardMst.isAdmin && boardMst.topNoticeYn === 'Y'">
                <el-col :span="12" >
                    <el-form-item label="상단공지 여부" >
                        <el-switch
                            v-model="article.topNoticeYn"
                            active-text="예"
                            inactive-text="아니오"
                            inactive-color="gray"
                            active-value="Y"
                            inactive-value="N"
                            @change="article.secretYn = article.topNoticeYn == 'Y' ? 'N' : article.secretYn"
                            >
                        </el-switch>
                        <span class="l-bar ml-3">* 상단공지는 게시판의 상단에 고정되는 공지글입니다.</span>
                    </el-form-item>
                </el-col>
               
            </el-row>    

            <el-form-item label="제목" prop="articleTitle" required>
                <el-input v-model="article.articleTitle" ></el-input>
            </el-form-item>

            <el-row >
                <el-col :span="12" v-if="boardMst.categoryYn === 'Y'"  >
                    <el-form-item label="분류" prop="category" required>
                        <el-select class="w-100" v-model="article.category" >
                            <el-option v-for="item in this.boardMst.categoryList"
                            :key="item.value" :label="item.value" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="boardMst.secretYn === 'Y' && article.topNoticeYn !== 'Y'" >
                    <el-form-item label="공개여부" >
                        <el-switch
                            class="article-write"
                            v-model="article.secretYn"
                            active-text="비밀글"
                            inactive-text="공개글"
                            active-color="#ff4949"
                            inactive-color="#13ce66"
                            active-value="Y"
                            inactive-value="N">
                        </el-switch>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="작성자" prop="writerNm" required>
                        <el-input  v-model="article.writerNm" :readonly="!boardMst.isAdmin && $store.state.account.userId !== null"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="boardMst.emailYn == 'Y'" :span="12">
                <el-form-item label="이메일" required>
                    <el-col :span="11">
                    <el-form-item prop="emailId" required>
                        <el-input v-model="article.emailId" ></el-input>
                    </el-form-item>
                    </el-col>
                    <el-col class="text-center" :span="2">@</el-col>
                    <el-col :span="11">
                    <el-form-item prop="emailDomain" >
                        <el-input v-model="article.emailDomain" ></el-input>
                    </el-form-item>
                    </el-col>
                </el-form-item>
                </el-col>
            </el-row>

            <el-row v-if="boardMst.readRoleAuthYn === 'Y' && boardMst.isAdmin" >
                <el-col :span="24">
                <el-form-item prop="roleSeqSet" label="공지 대상 선택" required>
                    <el-select style="width:100%" v-model="article.roleSeqSet" multiple filterable 
                        placeholder="게시글 공지 대상을 선택해주세요">
                        <el-option v-for="item in $store.state.common.roleOptions" :key="item.value" :label="item.text" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                </el-col>
            </el-row>

            

            <el-form-item v-if="boardMst.attachYn === 'Y'" label="첨부파일" >
                <el-col :span="24">    
                    <el-card shadow="never">                
                        <el-upload
                        action=""
                        class="upload-demo"
                        :auto-upload="false"
                        multiple
                        :on-remove="onFileChange"
                        :on-change="onFileChange"
                        :before-remove="onFileBeforeRemove"
                        :file-list="articleAttach">
                        <el-button size="medium" type="primary">업로드할 파일 추가선택</el-button> <span class="ml-3 text-medium-gray"><i class="el-icon-info"></i> 여러개 추가선택이 가능. (한번에 올릴 수 있는 용량은 파일들을 합쳐서 20M이하만 가능.)</span>
                        <div slot="tip" >
                           <span class="fs15">( {{ attachSize | fileSize }} / 20MB )</span>
                        </div>
                        </el-upload>
                    </el-card>
                </el-col>

            </el-form-item>

            <el-row v-if="boardMst.isNeedPassword" prop="writerPw" required>
                <el-col :span="12">
                    <el-form-item label="비밀번호" prop="writerPw" required>
                        <el-input type="password" v-model="article.writerPw" :placeholder="mode == 'edit'? '작성시 등록한 비밀번호 입력' :''"></el-input>
                    </el-form-item>    
                </el-col>

                <el-col :span="12" v-if="mode == 'write'">
                <el-form-item label="보안문자" prop="captcha" required>
                  <el-input v-model="article.captcha" style="width: 120px;"></el-input>
                  <img class="captcha ml-3" :src="captcha" /> <el-button @click="changeCaptchaUrl" class="ml-2" size="mini" round><i class="el-icon-refresh"></i> 새로고침</el-button>
                </el-form-item>
                </el-col>

            </el-row>            

            <vue-editor class="mt-3 ml-5 pb-5" style="height:500px" id="editor1" v-model="article.articleText" ></vue-editor>
            

        </el-form>    

        <div class="mt-5 text-center" :gutter="20">
                <el-button @click="submitForm" type="primary" icon="el-icon-edit">등 록</el-button>
                <el-button class="ml-3" type="default" icon="el-icon-back" @click="gotoList">취 소</el-button>
        </div>

    </div>

</template>

<script>
import BoardProxy from '@/proxies/BoardProxy'
import PasswordModal from './PasswordModal'
import {VueEditor} from "vue2-editor";
import CommonProxy from '@/proxies/CommonProxy';
import * as Util from '@/util/util'
import _ from 'lodash'

const validator =({required, onlyWord, domain, min, confirmPassword, phone, captcha}, vm) => {

    return (rule, value, callback) => {
    
        if(required && (!value || value.length === 0)) {
            callback( new Error('필수입력 항목입니다.'))
            return
        } else if(onlyWord && !/^[\w\-\.]+$/g.test(value) ) {
            callback( new Error('영문만 가능합니다.'))
            return
        } else if(domain && !/[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(value) ) {
            callback( new Error('이메일 형식만 가능합니다. ex)gmail.com'))
            return
        } else if(min && value.length < min ) {
            callback( new Error(`최소 ${min}자리 이상 이어야 합니다.`))
            return
        } else if(confirmPassword && vm.article.password !== vm.article.confirmPassword ) {
            callback( new Error('비밀번호가 일치하지 않습니다.'))
            return
        } else if(phone  && !/^[\d\-]+$/g.test(value) ) {
            callback( new Error('숫자 또는 -(하이픈)만 가능합니다.'))
            return
        } else if(captcha) {
            vm.debouncedCaptchaAnswer( value, callback )

        } else {
            callback()
        }
    
    }

} 

    
export default {
    components: {
        VueEditor
    },
    props: {
        mode: String,
        /*
        boardNo: String,
        articleNo: String
        */
    },
    methods: {
        download( {articleNo, attachNo} ) {

            //location.href = "/api/advertiser/contract/" + row.contractSeq + "/download?authorization=" + $cookies.get('id_token');

            return `/api/board/${this.boardMst.boardNo}/download/${articleNo}/${attachNo}?authorization=${$cookies.get('id_token')}`
        },
        onFileBeforeRemove(file, fileList) {
            // 업로드 되어있는 파일 삭제
            if(file.attachNo) {
                if(!confirm(file.name+'\n\n지금 삭제클릭한 파일은 이미 서버에 업로드된 파일입니다.\n서버에서 삭제하시겠습니까?')) {
                    return false
                }
                // 삭제할 리스트에 담는다.
                this.removeAttachList.push(file.attachNo)
            }
            return true

        },
        onFileChange(file, fileList) {
            
            const sameItem = fileList.find(item=> item !== file && item.name === file.name && item.size === file.size)

            if(sameItem) {
                fileList.splice( fileList.indexOf(sameItem), 1 )
            }

            let size = 0
            fileList.forEach(file=>size += (file.size || file.fileSize) )

            if(size > 20000000) {
                alert('파일용량이 20M를 초과했습니다.')
                fileList.splice( fileList.indexOf(file), 1 )
            }
            this.articleAttach = [...fileList]

            this.setUploadSize()

        },
        capchaValid( value, callback ) {

            new CommonProxy()
            .validCaptcha(value)
            .then(response => {
                if(!response.success) {
                    callback( new Error('보안문자가 일치하지 않습니다.'))
                } else {
                    callback()
                }
            })

        },
        setUploadSize() {

            let size = 0
            this.articleAttach.forEach(file=>size += (file.size || file.fileSize) )            
            this.attachSize = size           

        },
        async getArticle() {

            return new BoardProxy()
            .getArticle(this.boardNo, this.articleNo)
            .then(res=> {
                this.article = {...res.item, roleSeqSet: res.item.roleSeqSet || [] }
                this.articleAttach = [...res.articleAttach]
                this.replyAttach = [...res.replyAttach]

                this.setUploadSize()
                return res;
            })

        },
        pickClass( dest, value ) {

            return (this.boardMst[dest].find(item=>item.value === value) || {}).cls

        },
        gotoList() {
            this.$router.push({
                name: 'ArticleList',
                query: { ...this.$route.query }
            })
        },
        setEmail( value ) {
            console.log(value)
            this.article.writerEmail = `${this.article.emailId}@${this.article.emailDomain}`
        },
        changeCaptchaUrl() {
          this.captcha = '/api/common/captcha' + '?' + Util.random(1,10000)
          return this.captcha
        },
        parseEmail() {
            const tokens = this.article?.writerEmail?.split('@')
            if(tokens?.length > 1) {
                this.article = { ...this.article, emailId:tokens[0], emailDomain:tokens[1] }
            }
        },
        submitForm() {
            this.$refs.ruleForm.validate((valid) => {

              if (valid) {

                if(!this.article.articleText) {
                    alert('글 내용을 입력해 주세요')
                    return false;
                }

                new BoardProxy() 
                [this.mode === 'write'? 'createArticle' : 'updateArticle']( this.article, this.articleAttach, this.removeAttachList )
                .then(response => {
                    if(response.header.returnCode !== 'OK') {
                        alert(response.header.resultMessages)
                    } else {
                        if(this.mode === 'write') {

                            alert('등록 되었습니다.')
                            this.$router.push({
                                name: 'ArticleList',
                                params: {
                                    boardNo: this.boardMst.boardNo
                                }
                            })                            

                        } else {
                            alert('수정 되었습니다.')
                            this.gotoList()
                        }    
                    }
                })

              } else {
                  alert('필수 항목들을 빠짐없이 입력해 주세요')
                  return false;
              }
            })
        }

    },
    created() {
        
        this.debouncedCaptchaAnswer = _.debounce(this.capchaValid, 800)
        let isAuth = true

        // this.boardNo = this.$route.params.boardNo
        this.boardNo = this.$route.params.boardNo
        try {
            if(this.mode === 'edit') {
                //수정

                this.articleNo = this.$route.params.articleNo

                this.getArticle()
                .then(res=>{

                    if(!this.article.canUpdate) {
                        alert('잘못된 권한입니다.')
                        this.$router.push({name:'ArticleList',params:this.boardNo})
                    }

                })
                .then(this.parseEmail)

            } else {
                // 추가

                if(!this.boardMst.canInsert) {
                    isAuth = false
                    return
                }

                this.article = { 
                    boardNo: this.boardNo,
                    writerNm: this.$store.state.account.userName, 
                    writerEmail: this.$store.state.account.email,
                    htmlYn: this.boardMst.defaultHtmlYn,
                    roleSeqSet: [],
                    state: this.boardMst.defaultState,
                    articleText: this.boardMst.template,
                    secretYn: this.boardMst.secretDefault,
                    topNoticeYn: 'N'
                }

                this.parseEmail()
            }   
        } finally {
            if(!isAuth) {
                alert('잘못된 권한입니다.')
                this.$router.push({name:'Home'})
            }    
           
        }
        
        
    },
    computed: {
        boardMst() {
            return this.$store.state.board.boardMst
        },

    },
    watch: {
        'article.emailId': 'setEmail',
        'article.emailDomain': 'setEmail',
        'article.roleSeqSet' () {

            this.article.roleSeqStr = (this.article.roleSeqSet || []).toString()

        }
    },
    data() {
        return {
            attachSize: 0,
            action: undefined,
            removeAttachList: [],
            captcha: this.changeCaptchaUrl(),
            articleAttach: [],
            replyAttach: [],
            article: {
            },
            rules: {
                emailId: [
                    { trigger: 'blur', validator: validator({ required: true, onlyWord: true }) },
                    { trigger: 'change', validator: validator({ required: true, onlyWord: true }) }
                ],
                emailDomain: [
                    { trigger: 'blur', validator: validator({ required: true, domain: true }) },
                    { trigger: 'change', validator: validator({ required: true, domain: true }) }
                ],
                writerPw: [
                    { trigger: 'blur', validator: validator({ required: true, min: 4 }) },
                    { trigger: 'change', validator: validator({ required: true, min: 4 }) }
                ],
                confirmPassword: [
                    { trigger: 'blur', validator: validator({ required: true, confirmPassword: 'password' }, this) },
                    { trigger: 'change', validator: validator({ required: true, confirmPassword: 'password'}, this) }
                ],
                articleTitle: [
                    { trigger: 'blur', validator: validator({ required: true}) },
                    { trigger: 'change', validator: validator({ required: true}) },
                ],
                category: [
                    { trigger: 'blur', validator: validator({ required: true}) },
                    { trigger: 'change', validator: validator({ required: true}) },
                ],
                roleSeqSet: [
                    { trigger: 'blur', validator: validator({ required: true}) },
                    { trigger: 'change', validator: validator({ required: true}) },
                ],
                roleSeqArr: [
                    { trigger: 'blur', validator: validator({ required: true}) },
                    { trigger: 'change', validator: validator({ required: true}) },
                ],
                writerNm: [
                    { trigger: 'blur', validator: validator({ required: true}) },
                    { trigger: 'change', validator: validator({ required: true}) },
                ],
                captcha: [
                    { trigger: 'change', validator: validator({ required: true, captcha: true}, this) },
                    { trigger: 'blur', validator: validator({ required: true, captcha: true}, this) },
                ],

            },
        }
    }

}
</script>

<style lang="scss" >
.article-write { 
    .el-switch__label { color : rgb(184, 184, 184) }
    .el-switch__label.is-active { color: #409EFF; }
    .el-switch__label--right.is-active {
        color:red; 
    }    
}

</style>
<style scoped>
img.captcha { height: 40px; }
.el-form-item {
    margin-bottom: 22px !important;
}
</style>